const initialState = {};

// -------------------------------------------------------
// -------------------------------------------------------
const reducer = (state = initialState, action) => {
  // -------------------------------------------------------
  switch (action.type) {
    case "SET_DASHBOARD_DATA":
      return { ...state, dashboard: action.dashboard };

    default:
      return state;
  }
};

export default reducer;
